"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconWrapper = exports.InlineTopAlignWrapper = exports.ContentWrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentWrapper = _styledComponents.default.div.withConfig({
  displayName: "IconCardstyles__ContentWrapper",
  componentId: "zagcvi-0"
})(["color:", ";& >:first-child{padding-top:0;}& >:last-child{padding-bottom:0;}"], function (props) {
  return props.noGhost ? props.theme.c_foreground_overDark : 'inherit';
});

exports.ContentWrapper = ContentWrapper;

var InlineTopAlignWrapper = _styledComponents.default.div.withConfig({
  displayName: "IconCardstyles__InlineTopAlignWrapper",
  componentId: "zagcvi-1"
})(["display:flex;flex-direction:row;"]);

exports.InlineTopAlignWrapper = InlineTopAlignWrapper;

var IconWrapper = _styledComponents.default.div.withConfig({
  displayName: "IconCardstyles__IconWrapper",
  componentId: "zagcvi-2"
})(["line-height:1;margin-right:", ";"], function (props) {
  return props.theme.standardPadding;
});

exports.IconWrapper = IconWrapper;